<mat-card class="list-group mt-6">
  <mat-card-content
    class=""
    *ngFor="let notification of allNotifications"
    (click)="selectNotification(notification)"
    [class.list-group-item]="true"
    [class.active]="selectedNotification?.id === notification?.id"
    [class.unread]="!notification?.is_read"
  >
    <div (click)="markAsRead(notification)" class="cursor-pointer">
      {{ notification?.subject }}
      <p class="text-[12px]">
        {{
          notification?.data?.description || notification?.event_type
            | slice : 0 : 60
        }}
        {{
          (notification?.data?.description || notification?.event_type).length >
          50
            ? "..."
            : ""
        }}
        - {{ notification?.created_at | date : "short" }}
        <span *ngIf="notification?.is_obsolete" class="text-red-500"
          >(Obsolete)</span
        >
      </p>

      <span
        class="badge"
        [ngClass]="{
          'bg-info': notification?.notification_type === 'info',
          'bg-warning': notification?.notification_type === 'warning',
          'bg-danger': notification?.notification_type === 'alert'
        }"
      >
        {{
          notification?.stage === 1
            ? "Stage 1 Approval Request"
            : "Stage 2 Approval Request"
        }}
      </span>
    </div>
  </mat-card-content>
  <li *ngIf="allNotifications.length === 0" class="list-group-item text-muted">
    No notifications
  </li>
</mat-card>
